import ActDragRacing from '../jce/ActDragRacingServant.js'
import './wsChannel'
import { TafFetch } from '@huyafed/taf-fetch'
import { fetchProd, getURLParam } from '../utils/func'
import Mock from 'mockjs'
import { rich, auditionRanks, hourChampion, hour, carList } from './data'

const tafFetch = new TafFetch({
  isProd: fetchProd(),
});

const Random = Mock.Random

const isMock = getURLParam('mock');

export const areaList = [
  {
    sAreaName: '王牌',
    iArea: 1,
    className: 'tab1and2_nav1',
  },
  {
    sAreaName: '女神',
    iArea: 2,
    className: 'tab1and2_nav2',
  },
  {
    sAreaName: '峡谷',
    iArea: 3,
    className: 'tab1and2_nav3',
  },
  {
    sAreaName: '手游',
    iArea: 4,
    className: 'tab1and2_nav4',
  },
  {
    sAreaName: '网游',
    iArea: 5,
    className: 'tab1and2_nav5',
  },
  {
    sAreaName: '热游',
    iArea: 6,
    className: 'tab1and2_nav6',
  },
  {
    sAreaName: '明星',
    iArea: 7,
    className: 'tab1and2_nav7',
  },
  {
    sAreaName: '大咖',
    iArea: 8,
    className: 'tab1and2_nav8',
  },
  {
    sAreaName: '红人',
    iArea: 9,
    className: 'tab1and2_nav9',
  },
  {
    sAreaName: '交友',
    iArea: 10,
    className: 'tab1and2_nav10',
  },
  {
    sAreaName: '颜值',
    iArea: 11,
    className: 'tab1and2_nav11',
  },
]

const rankItemMock = () => {
  const count = Random.natural(1, 50);
  const data = [];
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < count; i++) {
    const newData = {
      iRank: i + 1,
      'lScore|': Random.natural(0, 99999999),
      sNickName: Random.name(true),
      sLogoUrl: Random.image(),
      'iPromoteStatus|0-3': 0,
      sDesc: Random.paragraph(),
      'iStarAreaId|0-2': 0,
      'sPortraitUrl|1': [
        '//diy-assets.msstatic.com/hyys/activity/202010YX311913984.png',
        '//diy-assets.msstatic.com/hyys/activity/202010WDtongzi.png',
        '//diy-assets.msstatic.com/hyys/activity/202010YX2212141748.png',
        '//diy-assets.msstatic.com/hyys/activity/202010YX500066171.png',
        '//diy-assets.msstatic.com/hyys/activity/202010YX1784500555.png',
      ],
      tJump: {
        'lPid|0-99999999': 0,
        'iGameId|0-9999999': 0,
        'iRoomId|0-99999999': 0,
        'iIsLive|0-1': 0,
      },
    }
    data.push(newData);
  }
  return Mock.mock({
    value: data,
  });
}

/* 公共结构体 */
export interface RankItem {
  iRank: number,
  lScore: number,
  sNickName: string,
  sLogoUrl: string,
  tJump: JumpChannel,
  iPromoteStatus: number,
  sDesc: string,
  iStarAreaId: number,
  sPortraitUrl: string,

}
export interface JumpChannel {
  lPid: number,       // 主播Uid
  iGameId: number,    // 品类id
  iRoomId: number,    // roomid
  iIsLive: number,      // 是否在播
}

// 获取阶段
type StageReq = (
  option: {
    lPid: number,
  }
) => Promise<StageRsp>
export interface StageRsp {
  iStage: number,  // 阶段 @STAGE
  iAreaId: number, // 主播所在分区
}
const getStage202108: StageReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getStage202108', option, ActDragRacing.StageReq, ActDragRacing.StageRsp);
  new Promise(resolve => {
    resolve(
      { iStage: 4, iAreaId: 1 },
    );
  })


// 神豪榜单
type RichRankReq = (
  option: {
    lPid: number,
  }
) => Promise<RichRankRsp>
export interface RichRankRsp {
  vItem: {
    value: RankItem[],
  },
}
const getRichRank202108: RichRankReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getRichRank202108', option, ActDragRacing.RichRankReq, ActDragRacing.RichRankRsp);
  // return new Promise(resolve => {
  //   resolve({
  //     vItem: rankItemMock(),
  //   });
  // })
  new Promise(Resolve => {
    Resolve(rich)
  })


// 分区阶段
type AuditionRankReq = (
  option: {
    lPid: number,
    iAreaId: number,
    iStage: number,
    iRevive?: number,
  }
) => Promise<AuditionRankRsp>
export interface AuditionRankRsp {
  vItem: {
    value: RankItem[],
  },
  tItem: RankItem,
  sMatchDesc: string,
}
export interface AuditionRank {
  vItem: { value: RankItem[] },
  iArea: number,
  tItem: RankItem,
  sDesc: string,
}
const getStageRank202108: AuditionRankReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getStageRank202108', option, ActDragRacing.AreaRankReq, ActDragRacing.AreaRankRsp);
  // return new Promise(resolve => {
  //   resolve(
  //     Mock.mock({
  //       vItem: rankItemMock(),
  //       tItem: rankItemMock().value[0],
  //       sMatchDesc: '23日排名前20名主播晋级',
  //     }),
  //   );
  // })
  new Promise(Resolve => {
    Resolve(auditionRanks['iStage' + option.iStage]['iAreaId' + option.iAreaId])
  })




// 淘汰赛榜单
// type EliminationRankReq = (
//   option: {
//     lPid: number,
//     iAreaId: number,
//   }
// ) => Promise<EliminationRankRsp>
// export interface EliminationRankRsp {
//   vRankList: {
//     value: EliminationRank[],
//   },
// }
// export interface EliminationRank {

//   vTeamA: { value: RankItem[] },
//   vTeamB: { value: RankItem[] },
//   sDescA: string,
//   sDescB: string,
//   iAreaId: number,
//   tItem: RankItem,
// }
// const getEliminationRank202106: EliminationRankReq = option =>
//   // if (!isMock) return tafFetch.tafFetch('getEliminationRank202106', option, Act2021DragonBoat.EliminationRankReq, Act2021DragonBoat.EliminationRankRsp);
//   // return new Promise(resolve => {
//   //   resolve(
//   //     Mock.mock({
//   //       vRankList: {
//   //         'value': [
//   //           {
//   //             'iAreaId|+1': 1,
//   //             vTeamA: rankItemMock(),
//   //             vTeamB: rankItemMock(),
//   //             tItem: rankItemMock().value[0],
//   //             'sDescA|1-5': 'A组晋级描述',
//   //             'sDescB|1-5': 'B组晋级描述',
//   //           },
//   //         ],
//   //       },
//   //     }),
//   //   );
//   // })
//   new Promise(Resolve => {
//     Resolve(eliminationRank['iAreaId' + option.iAreaId])
//   })



// 决赛榜单
// type FinalRankReq = (
//   option: {
//     lPid: number,
//     iAreaId: number,
//   }
// ) => Promise<FinalRankRsp>
// export interface FinalRankRsp {
//   vRankList: {
//     value: FinalRank[],
//   },
// }
// export interface FinalRank {
//   iArea: number,
//   vItem: { value: RankItem[] },
//   sDesc: string,
// }
// const getFinalRank202106: FinalRankReq = option =>
//   // if (!isMock) return tafFetch.tafFetch('getFinalRank202106', option, Act2021DragonBoat.FinalRankReq, Act2021DragonBoat.FinalRankRsp);
//   // return new Promise(resolve => {
//   //   resolve(
//   //     Mock.mock({
//   //       vRankList: {

//   //         'value': [
//   //           {
//   //             'iAreaId|+1': 1,
//   //             vItem: rankItemMock(),
//   //             'sDesc|1-5': '决赛晋级描述',
//   //           },
//   //         ],
//   //       },
//   //     }),
//   //   );
//   // })
//   new Promise(Resolve => {
//     Resolve(finalRank['iAreaId' + option.iAreaId])
//   })


// 车队贡献榜
type ContributeReq = (
  option: {
    lPid: any,
  }
) => Promise<ContributeRsp>
export interface ContributeRsp {
  lScore: number,
  vList: { value: ContributeItem[] },
}
export interface ContributeItem {
  iRank: number,
  lScore: number,
  sMotorcadeName: string,
  sFlagName: string,
  vMemberList: { value: MemberItem[] },
  tPersenter: GuardPresenter,
}
export interface GuardPresenter {
  sNickName: string,
  sLogoUrl: string,
}

export interface MemberItem {
  tJump: JumpChannel,
  sNickName: string,
  sLogoUrl: string,
}

const getContribute202108: ContributeReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getContribute202108', option, ActDragRacing.GetContributeReq, ActDragRacing.GetContributeRsp);
  // return new Promise(resolve => {
  //   resolve(
  //     Mock.mock({
  //       lScore: 211,
  //       vList: {
  //         'value|0-24': [
  //           {
  //             iRank: 1,
  //             lScore: 135555,
  //             sMotorcadeName: '要人和和和和产',
  //             sFlagName: '我啊',
  //             vMemberList: {
  //               'value|1-2': [
  //                 {
  //                   tJump: {},
  //                   sNickName: 'dfdf',
  //                   sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1046/a6/b3416cb7e0294bac9851d1a58d2219_180_135.jpg?1622902238',
  //                 },
  //                 {
  //                   tJump: {},
  //                   sNickName: 'dfdf',
  //                   sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1092/06/292bc32f52a9e85cb303d3ad694e9d_180_135.jpg?1611734853',
  //                 },
  //               ],
  //             },
  //             tPersenter: {
  //               sNickName: '你你',
  //               sLogoUrl: 'https://huyaimg.msstatic.com/avatar/1092/06/292bc32f52a9e85cb303d3ad694e9d_180_135.jpg?1611734853',
  //             },
  //           },
  //         ],
  //       },
  //     }),
  //   );
  // })
  new Promise(Resolve => {
    Resolve(carList)
  })



// 小时榜单
type HourRankReq = (
  option: {
    lPid: number,
    iAreaId: number,
  }
) => Promise<HourRankRsp>
export interface HourRankRsp {
  iHour: number,
  vItem: { value: RankItem[] },
  tItem: RankItem,
}
const getHourRank202108: HourRankReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getHourRank202108', option, ActDragRacing.HourRankReq, ActDragRacing.HourRankRsp);
  // return new Promise(resolve => {
  //   resolve(
  //     Mock.mock({
  //       iHour: 2,
  //       vItem: rankItemMock(),
  //       tItem: rankItemMock().value[0],
  //     }),
  //   );
  // })
  new Promise(Resolve => {
    Resolve(hour['iAreaId' + option.iAreaId])
  })


// 小时冠军
type HourChampionReq = (
  option: {
    iAreaId: number,
  }
) => Promise<HourChampionRsp>
export interface HourChampionRsp {
  vItem: {
    value: {
      iHour: number,
      tItem: {
        value: HourChampion[]
      }
    }
  }
}
export interface HourChampion {
  iHour: number,
  sNickName: string,
  sLogoUrl: string,
  tJump: JumpChannel,
  iRank: number,
  lScore: number,
  iPopularity: number,
  // vMotorcadeList: //加入的车队列表
}
const getHourChampion202108: HourChampionReq = option =>
  // if (!isMock) return tafFetch.tafFetch('getHourChampion202108', option, ActDragRacing.HourChampionReq, ActDragRacing.HourChampionRsp);
  // return new Promise(resolve => {
  //   resolve(
  //     Mock.mock({
  //       vItem: {
  //         'value|0-6': [
  //           {
  //             'iHour|+1': 1,
  //             tItem: {
  //               sNickName: Random.name(true),
  //               'sLogoUrl|1': [
  //                 '//huyaimg.msstatic.com/avatar/1029/b2/ee41d2852950832ef20939181496d9_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1032/67/7dc20834eecfe9a9ca69a77087072b_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1098/0d/2faeef1fa5b396273c9fc9e7deb15c_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1071/6f/4312ff971c74e56591a632782a276f_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1097/d1/876d9351d7a7367237bad6194b2cfb_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1029/b2/ee41d2852950832ef20939181496d9_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1032/67/7dc20834eecfe9a9ca69a77087072b_180_135.jpg',
  //                 '//huyaimg.msstatic.com/avatar/1098/0d/2faeef1fa5b396273c9fc9e7deb15c_180_135.jpg',
  //               ],
  //               tJump: {
  //                 'lPid|0-99999999': 0,
  //                 'iGameId|0-9999999': 0,
  //                 'iRoomId|0-99999999': 0,
  //                 'iIsLive|0-1': 0,
  //               },
  //               iRank: 1,
  //               lScore: 2333,
  //               iPopularity: 13223,
  //             },

  //           },
  //         ],
  //       },
  //     }),
  //   );
  // })
  new Promise(Resolve => {
    Resolve(hourChampion['iAreaId' + option.iAreaId])
  })



const fetch = {
  getRichRank202108,
  getStage202108,
  getStageRank202108,
  // getEliminationRank202106,
  // getFinalRank202106,
  getHourRank202108,
  getHourChampion202108,
  getContribute202108,
}
export {
  fetch,
}
